<template>
  <div class="animated fadeInUp">
    
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t("edit") }} Segment</div>
      <router-link class="btn-blue" :to="{name:'Segments'}">Segments {{ $tc("list") }}</router-link>
    </div>

    <div class="white-wrapper pb-0 overflow-hidden">
      <div class="row">
        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <input
              v-model="segment_name"
              id="segment_name"
              name="segment_name"
              v-validate="'required'"
              type="text"
              placeholder="."
            />
            <label>Segment Name</label>
          </div>
          <p
            v-if="errors.has('segment_name')"
            class="error_message"
          >{{ errors.first(`${'segment_name'}`)}}</p>
        </div>
        <div class="col-lg-6 col-xl-3 mb-4">
          <div class="input-material">
            <input
              name="segment_type"
              v-validate="'required'"
              v-model="segment_type"
              type="text"
              placeholder="."
            />
            <label>Segment Type</label>
          </div>
          <p
            v-if="errors.has('segment_type')"
            class="error_message"
          >{{ errors.first(`${'segment_type'}`)}}</p>
        </div>

        <div class="col-lg-6 col-xl-2 mb-4 align-self-center">
          <div class="d-flex align-items-center">
            <label class="mb-0 mr-2">Active</label>
            <b-form-checkbox v-model="segment_is_active" switch></b-form-checkbox>
          </div>
        </div>

        <div class="col-lg-6 col-xl-2 mb-4 align-self-center">
          <button
            :disabled="btenable"
            class="btn btn-blue w-100 px-2"
            @click.prevent.stop="onFinalSubmit()"
          >Edit Segment</button>
        </div>

        <div class="col-12 border-top p-4">
          <div class="row">
            <div class="col-8 mb-4 align-self-center">
              <h5 class="mb-0">Customer List</h5>
            </div>
            <div class="col-12 mb-4 row">
              <div class="col-2 m-0 pr-3">
                <b-dropdown :text="filter ? filter : 'Filter'"
                variant="dropdown-curve"
                class="ml-auto">
                <b-dropdown-item
                  v-for="(filter, FilterIndex) in Filter"
                  :key="FilterIndex"
                  @click.prevent.stop="onSelectEventFilter('Filter', filter)"
                  >{{ filter.filter_name }}
                </b-dropdown-item>
              </b-dropdown>
              </div>
              <div class="col-9" v-if="filter == 'Email'">
                <div class="input-material">
                <input
                  type="text"
                  v-debounce:1000="getFilteredCustomers"
                  v-model="search"
                  placeholder="."
                />
                <label class="bg-light">Filter by Email</label>
              </div>
              </div>
              <div class="col-9 row" v-if="filter == 'Event'">
                <div class="col-3">
              <b-dropdown :text="event_name ? event_name : 'Select Event Name'"
              variant="dropdown-curve"
                class="ml-auto w-100">
                <b-dropdown-item
                  v-for="(action, actionIndex) in actionDataTypes"
                  :key="actionIndex"
                  @click.prevent.stop="onSelectEventFilter('Action', action)"
                  >{{ action.field_name }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-3" v-if="selectedEvent && selectedEvent.field_type == 'Number'">
              <b-dropdown :text="event_condition ? event_condition : 'Condition'"
              variant="dropdown-curve"
              class="ml-auto w-100">
              <b-dropdown-item
                v-for="(rule, ruleIndex) in conditionRules"
                :key="ruleIndex"
                @click.prevent.stop="onSelectEventFilter('Condition', rule)"
                >{{ rule.condition_rule_name }}</b-dropdown-item>
              </b-dropdown>
            </div>
            <div class="col-4" v-if="event_name">
              <div class="input-material w-100">
                <input
                  type="text"
                  v-debounce:1000="getFilteredCustomers"
                  v-model="event_value"
                  placeholder="."
                />
                <label class="bg-light">Filter by {{event_name}}</label>
              </div>
            </div>
              </div>
            </div>
            <!-- <div class="col-4 mb-4">
              <div class="input-material">
                <input
                  type="text"
                  v-debounce:1000="getFilteredCustomers"
                  v-model="search"
                  placeholder="."
                />
                <label class="bg-light">Filter by Email</label>
              </div>
            </div> -->
            <!-- <div class="card" v-for="(post,i) in filteredList" :key="i">{{post.cust_email}}</div> -->
            <div class="col-12">
              <table class="table">
                <thead>
                  <tr style="text-align:center">
                    <th>Customer ID</th>
                    <th>Customer Name</th>
                    <th>Mobile Number</th>
                    <th>Email Address</th>
                    <th class="text-center">
                      <div class="row">
                        <div class="col-5">
                          Actions
                        </div>
                        <div class="col-3">
                          <b-form-checkbox
                        class="j-checkbox"
                        v-model="selectAll"
                      />
                        </div>
                      </div>
                      </th>
                  </tr>
                </thead>
                <tbody v-if="customerlist.length == 0">
                  <tr>
                    <td colspan="4">
                      <h3 class="text-center">{{ 'No records found' }}</h3>
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr v-for="(customer, customerIndex) in customerlist" :key="customerIndex">
                    <td style="text-align:right;">{{customer.cust_id}}</td>
                    <td>{{customer.first_name?customer.first_name:"-"}} {{customer.last_name}}</td>
                    <td style="text-align:right;">{{customer.cust_mobile?customer.cust_mobile:-""}}</td>
                    <td>{{customer.cust_email?customer.cust_email:"-"}}</td>
                    <td class="text-center">
                      <b-form-checkbox
                        class="j-checkbox"
                        :value="customer.cust_id"
                        v-model="selected_customers"
                        @change="checker($event,customer.cust_id)"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <!-- <div class="row mt-4">
       <multiselect
                v-model="selected_filter"
                placeholder="Select Filter"
                track-by="filter_name"
                label="filter_name"
                :options="filters"
              ></multiselect>
      <div class="col-3 input-material">
        <input type="text" v-model="filter_data" v-if="selected_filter" />
      </div>
      <button class="btn-blue" @click="fetchCustomer" variant="default">Fetch</button>
    </div>-->
  </div>
</template>

<script>
import MarketingAutomation from "@/services/MarketingAutomationService";
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
export default {
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      segments: [],
      selected_segment: null,
      customerlist: [],
      selected_customers: [],

      btenable: false,
      filters: [
        { filter_name: "Email", filter_value: "cust_email" },
        { filter_name: "Phone Number", filter_value: "cust_mobile" }
      ],
      selected_filter: null,
      filter_data: null,
      segment_name: "",
      segment_type: "",
      segment_is_active: true,
      search: null,
      removeCustomerId: [],
      event_name: null,
      event_rules: null,
      event_value: null,
      selectedEvent: "",
      event_condition: null,
      filter: "", 
      Filter: [
        {filter_id: 1, filter_name: 'Email'},
        {filter_id: 2, filter_name: 'Event'}
      ],
    };
  },

  // computed: {
  //   filteredList() {
  //     if (this.customerlist.length > 0) {
  //       return this.customerlist.filter(post => {
  //         if (post.cust_email === null) return;
  //         else {
  //           return post.cust_email
  //             .toLowerCase()
  //             .includes(this.search.toLowerCase());
  //         }
  //       });
  //     }
  //   }
  // },
  // watch: {
  //   search: function(newVal) {
  //     if (newVal) {
  //       console.log("newVal :", newVal);
  //     }
  //   }
  // },

  computed: {
    selectAll: {
      // get: function () {
      //     return this.customerlist ? this.selected_customers.length == this.customerlist.length : false;
      // },
      set: function (value) {
          var selected = [];

          if (value) {
              this.customerlist.forEach(function (user) {
                  selected.push(user.cust_id);
              });
          }

          this.selected_customers = selected;
      }
  },
  ...mapGetters([
      "actionDataTypes",
      "conditionRules",
    ]),
  },
  beforeMount() {
    this.getSingleSegment();
  },
  mounted() {
    this.getSegments();
    this.getCustomers();
    this.getActionDataType();
    this.getConditionRules();
  },
  methods: {
    ...mapActions([
      "getActionDataType",
      "getConditionRules"
    ]),
    checker(event, checkbox) {
      console.log("event :", event);
      console.log("checkbox :", checkbox);
      if (event === null && checkbox !== null) {
        this.removeCustomerId.push(checkbox);
        console.log("removeCustomerId :", this.removeCustomerId);
      }
    },
    getSingleSegment() {
      const { segment_id } = this.$route.params;
      MarketingAutomation.GetSingleSegment({
        segment_id: segment_id
      })
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            // console.log("data.Records :", data.Records);
            this.segment_name = data.Records[0].segment_name;
            this.segment_type = data.Records[0].segment_type;
            for (let i in data.Records) {
              this.selected_customers.push(
                data.Records[i].cust_id
                // first_name: data.Records[i].first_name
              );
              console.log('this.selected_customers', this.selected_customers)
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onSelectEventFilter(type, filter) {
      if(type == 'Action') {
        this.event_condition = null
        this.event_rules = null
        this.event_value = null
        this.event_name = filter.field_name
        this.selectedEvent = filter
      } else if (type == 'Condition') {
        this.event_condition = filter.condition_rule_name
        if(filter.condition_rule_name == 'Greater than') {
          this.event_rules = '>'
        } else if(filter.condition_rule_name == 'Less than') {
          this.event_rules = '<'
        } else if(filter.condition_rule_name == 'Equal to') {
          this.event_rules = '='
        } else if(filter.condition_rule_name == 'Less than equal to') {
          this.event_rules = '<='
        } else if(filter.condition_rule_name == 'Greater than equal to') {
          this.event_rules = '>='
        } else if(filter.condition_rule_name == 'Is not equal to') {
          this.event_rules = '!='
        }
      } else if(type == 'Filter') {
        this.filter = filter.filter_name
      }
    },
    getSegments() {
      MarketingAutomation.getSegments()
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.segments = data.Records;

            console.log("this.segments :", this.segments);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onChangePagination: function(event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getCustomers();
      } else {
        this.currentPage = event;
        this.getCustomers();
      }
    },
    getCustomers() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage
      };
      MarketingAutomation.GetCustomers(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            this.customerlist = data.Records;

            this.rows = data.totalRows;

            console.log("this.customerlist :", this.customerlist);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    getFilteredCustomers() {
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        cust_email: this.search,
        cust_email: this.search,
        event_name: this.event_name,
        event_value: this.event_value,
        event_rules: this.event_rules
      };
      MarketingAutomation.GetFilteredCustomers(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status) {
            if(data.Records && data.Records.length > 0) {
              this.customerlist = data.Records;
            } else {
              this.customerlist = [];
            }

            this.rows = data.totalRows;

            console.log("this.customerlist :", this.customerlist);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    onFinalSubmit(flag) {
      const { segment_id } = this.$route.params;

      //   this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          if (this.selected_customers.length > 0) {
            this.btenable = true;
            let payload = {
              segment_id: segment_id,
              segment_name: this.segment_name,
              segment_type: this.segment_type,
              customerId: this.selected_customers,
              segment_is_active: this.segment_is_active,
              removeCustomerId: this.removeCustomerId
            };
            MarketingAutomation.UpdateSegment(payload)
              .then(response => {
                this.btenable = false;
                const { data } = response;
                if (data.status) {
                  this.$toasted.show(data.message);
                  // if (flag) {
                  this.$router.push({
                    name: "Segments"
                  });
                  // } else {
                  //   this.submitted = false;
                  // }
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(this._CatchError);
          } else {
            this.$toasted.show("Please select some customers");
          }
        } else {
          this.$toasted.show("Please enter all details");
        }
      });
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/MarketingAutomationContainer/Segments/editSegment.vue